module.exports = __webpack_public_path__ + "img/s-skills-active.8af1bbfe.svg";